// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"85b18e48","223":"94317968","239":"722da8b1","504":"943f4369","921":"cbdd1272","946":"accc0d52"}[chunkId] + ".chunk.js";
};